import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { ReactNode } from 'react';

import { ApolloWrapper } from './lib/apollo';
import { DialogParameters, DialogProvider } from './providers/DialogProvider';
import { MessageChannelProvider } from './providers/MessageChannelProvider';
import './styles/index.css';

interface Props {
  children: ReactNode;
  apolloClient: ApolloClient<NormalizedCacheObject>;
  dialogParams: DialogParameters;
}

export const WidgetWrapper = ({
  children,
  apolloClient,
  dialogParams,
}: Props) => {
  return (
    <ApolloWrapper client={apolloClient}>
      <MessageChannelProvider>
        <DialogProvider params={dialogParams}>{children}</DialogProvider>
      </MessageChannelProvider>
    </ApolloWrapper>
  );
};
